import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../../general/title"
import { Line, HorizontalBar } from "react-chartjs-2"
import moment from "moment"
import { withRouter, Link } from "react-router-dom"
import _ from "lodash"
import { defaults } from "react-chartjs-2"
import { graphOptions, graphTheme } from "../../../graphTheme"
import Modal from "react-responsive-modal"
import { Formik, Field, Form } from "formik"
import submitData from "helpers/submitData"
import settings from "settings"
import fieldStatus from "helpers/fieldStatus"
import transformOptionsObject from "helpers/transformOptionsObject"
import fields from "models/trafficGrouped"
import ReactSelect from "components/ReactSelect"
import NumberField from "components/NumberField"
import * as Yup from "yup"
import DateField from "components/DateField"
import { toast } from "react-toastify"
import currentUser from "helpers/currentUser"
import FullTable from "components/FullTable"
import CoPilotTexting from "components/CoPilotTexting"
import TableRowField from "components/TableRowField"

_.merge(defaults, graphTheme)

class Traffic extends Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: true,
			valid: false,
			currentUser: currentUser(),
			groupedTraffic: false,
			iColumns: [
				{
					Header: "First Name",
					accessor: "first",
				},
				{
					Header: "Last Name",
					accessor: "last",
				},
				{
					Header: "Email",
					accessor: "email",
				},
				{
					Header: "Traffic Date",
					accessor: "date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
				},
			],
			gColumns: [
				{
					Header: "Lot Type",
					accessor: "lot_type",
				},
				{
					Header: "Prospect Count",
					accessor: "prospect",
				},
				{
					Header: "Realtor Count",
					accessor: "realtor",
				},
				{
					Header: "Traffic Date",
					accessor: "date",
					Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
					sort: "desc",
				},
			],
		}
		graphOptions.plugins = {
			datalabels: { display: false },
		}
	}

	validation = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else {
			let shape = {
				property: Yup.number().moreThan(0).required("Required"),
				builder: Yup.number().moreThan(0).required("Required"),
				lot_type: Yup.number().moreThan(0).required("Required"),
				prospect_count: Yup.number().typeError("Please enter a number.").required("Required"),
				realtor_count: Yup.number().typeError("Please enter a number.").required("Required"),
				traffic_date: Yup.number()
					.moreThan(0, "Please enter a date.")
					.required("Required")
					.typeError("Please enter a value."),
			}
			if (settings?.enabled?.sectionsOnTraffic) {
				shape.section_id = Yup.number()
					.moreThan(0, "Please choose a section.")
					.required("Required")
					.typeError("Please choose a section.")
			}
			return Yup.object().shape(shape)
		}
	}

	validationRows = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else {
			let shape = {
				property: Yup.number().moreThan(0).required("Required"),
				builder: Yup.number().moreThan(0).required("Required"),
				lot_type: Yup.number().moreThan(0).required("Required"),
				trafficRows: Yup.array().of(
					Yup.object().shape({
						source: Yup.number().moreThan(0).typeError(`Please choose a source.`).required("Required"),
						prospect_count: Yup.number().typeError("Please enter a number.").required("Required"),
						realtor_count: Yup.number().typeError("Please enter a number.").required("Required"),
					})
				),
				traffic_date: Yup.number()
					.moreThan(0, "Please enter a date.")
					.required("Required")
					.typeError("Please enter a value."),
			}
			if (settings?.enabled?.sectionsOnTraffic) {
				shape.section_id = Yup.number()
					.moreThan(0, "Please choose a section.")
					.required("Required")
					.typeError("Please choose a section.")
			}
			return Yup.object().shape(shape)
		}
	}

	trafficSourcesChart = () => {
		// Need to count traffic and sale sources, traffic should come in the payload
		var [labels, dataArray, sorted, f] = [[], {}, [], []]
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.traffic_source in dataArray) {
				dataArray[v.traffic_source]++
			} else {
				dataArray[v.traffic_source] = 1
			}
		})
		_.forEach(this.props.payload.traffic.split, (v, k) => {
			if (k in dataArray) {
				dataArray[k] += v
			} else {
				dataArray[k] = v
			}
		})
		for (var source in dataArray) {
			sorted.push([source, dataArray[source]])
		}
		sorted
			.sort(function (a, b) {
				return a[1] - b[1]
			})
			.reverse()
		_.forEach(sorted, (v) => {
			if (v[0] !== "0") {
				f.push(v[1])
				labels.push(this.props.payload.public.trafficSources[v[0]])
			}
		})
		const data = {
			labels: labels,
			datasets: [
				{
					label: "Sold",
					backgroundColor: "#3194EC",
					hoverBackgroundColor: "rgba(50,149,236,0.5)",
					hoverBorderColor: "rgba(50,149,236,0.9)",
					data: f,
				},
			],
		}

		const opts = {
			plugins: {
				datalabels: { display: false },
			},
			scales: {
				xAxes: [
					{
						stacked: true,
					},
				],
				yAxes: [
					{
						stacked: true,
					},
				],
			},
		}

		return <HorizontalBar data={data} options={opts} />
	}

	renderTraffic = () => {
		if (
			_.has(this.props.payload, "traffic.current.entries") &&
			this.props.payload.traffic.current.entries !== null
		) {
			var traffic = this.props.payload.traffic.current.map((sale) => {
				return (
					<tr key={sale.id}>
						<td>{sale.name}</td>
						<td>{this.props.payload.trafficSources[sale.source]}</td>
						<td>{moment.unix(sale.addedDate).format("MM/DD/YYYY")}</td>
						<td>
							{/*<Link to={`/entry/traffic/edit/${sale.id}`}><i className="fal fa-pencil"></i></Link>*/}
						</td>
					</tr>
				)
			})
			return (
				<table className="tableData">
					<thead>
						<tr>
							<th>Name</th>
							<th>Source</th>
							<th>Date</th>
							<th></th>
						</tr>
					</thead>
					<tbody>{traffic}</tbody>
				</table>
			)
		} else {
			return ""
		}
	}

	buildTable = () => {
		var ret = []
		_.forEach(this.props.payload.traffic.current.entries, (r) => {
			var v = {}
			v.first = r.first_name
			v.last = r.last_name
			v.email = r.email
			v.date = r.traffic_date

			ret.push(v)
		})

		ret = _.sortBy(ret, "date").reverse()

		return ret
	}

	buildGroupedTable = () => {
		let user = currentUser()
		var ret = []
		_.forEach(this.props.payload.traffic.current.grouped.array, (r) => {
			if (r.user !== user.id) {
				return
			}
			var v = {}
			let lotType = _.find(this.props.payload.public.lot_types, { id: r.lot_type })

			v.realtor = r.realtor_count
			v.prospect = r.prospect_count
			v.lot_type = lotType ? lotType.name : ""
			v.date = r.traffic_date

			ret.push(v)
		})
		ret = _.sortBy(ret, "date").reverse()
		return ret
	}

	submitClasses = (f) => {
		var classNames = require("classnames")
		var submitClasses = classNames("form__submit", {
			"form__submit--ready": f,
		})

		return submitClasses
	}

	lotTypes = (f) => {
		if (!f.values.property) {
			return []
		} else {
			let arr = []
			_.forEach(this.props.payload.salespersonPayload.lot_types, (v) => {
				// Logic to ensure the selected property + builder is only showing the correct lot types
				let propLotTypes = _.find(this.props.payload.public.builders, { id: f.values.builder })
				if (!propLotTypes?.lot_types?.[f.values.property]?.includes(v.value)) return

				if (v.property == f.values.property) {
					arr.push(v)
				}
			})
			return arr
		}
	}

	options = (f, name) => {
		let ret = []
		this.props.payload.public[name].forEach((v) => {
			if (f.values.property && f.values.property == v.property) {
				ret.push({ label: v.name, value: v.id })
			}
		})

		ret = _.sortBy(ret, "label")
		return ret
	}

	formLayout = (f) => {
		let propertyOptions = []
		_.forEach(this.props.payload.salespersonPayload.info.properties, (v) => {
			let b = _.find(this.props.payload.public.properties, { id: v })
			if (b) {
				propertyOptions.push({ value: v, label: b.name })
			}
		})
		//? Sections on traffic.
		let sections
		try {
			if (settings?.enabled?.sectionsOnTraffic) {
				let opts = []
				let secs = []
				//? All the sections this builder has models in.
				_.forEach(this.props.payload.salespersonPayload.models, (v) => {
					if (!secs.includes(v.section_id)) {
						secs.push(v.section_id)
					}
				})
				_.forEach(this.props.payload.public.sections, (v) => {
					if (v.property == f.values.property && secs.includes(v.id)) {
						opts.push({ value: v.id, label: v.name })
					}
				})
				sections = (
					<li className={`${fieldStatus("section_id", f)}`}>
						<label htmlFor="section">
							Section <sup>*</sup>
						</label>
						{f.errors.length > 0 && f.errors.section_id && f.touched.section_id && (
							<div className="form__message">{f.errors.section_id}</div>
						)}
						<ReactSelect
							name={`section_id`}
							options={opts}
							value={f.values.section_id}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return (
			<div>
				{/* console.log(f) */}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("property", f)}>
							<label htmlFor="property">Community</label>
							{f.errors.length > 0 && f.errors.property && f.touched.property && (
								<div className="form__message">{f.errors.property}</div>
							)}
							<ReactSelect
								name={`property`}
								options={propertyOptions}
								value={f.values.property}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						<li className={fieldStatus("builder", f)}>
							<label htmlFor="builder">
								Builder <sup>*</sup>
							</label>
							{f.errors.length > 0 && f.errors.builder && f.touched.builder && (
								<div className="form__message">{f.errors.builder}</div>
							)}
							<ReactSelect
								name={`builder`}
								options={transformOptionsObject(this.props.payload.salespersonPayload.builders)}
								value={f.values.builder}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{sections}
						<li className={fieldStatus("traffic_date", f)}>
							<label htmlFor="traffic_date">
								Traffic Date <sup>*</sup>
							</label>
							{f.errors.traffic_date && f.touched.traffic_date && (
								<div className="form__message">{f.errors.traffic_date}</div>
							)}
							<DateField
								name="traffic_date"
								className="form__textarea"
								value={f.values.traffic_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.traffic_date}
								error={f.errors.traffic_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("lot_type", f)}>
							<label htmlFor="lot_type">Lot Type *</label>
							{f.errors.length > 0 && f.errors.lot_type && f.touched.lot_type && (
								<div className="form__message">{f.errors.lot_type}</div>
							)}
							<ReactSelect
								name={`lot_type`}
								options={this.lotTypes(f)}
								value={f.values.lot_type}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{settings.enabled && settings.enabled.subdivisionOnTraffic && (
							<li className={fieldStatus("subdivision", f)}>
								<label htmlFor="subdivision">Subdivision</label>
								{f.errors.length > 0 && f.errors.subdivision && f.touched.subdivision && (
									<div className="form__message">{f.errors.subdivision}</div>
								)}
								<ReactSelect
									name={`subdivision`}
									options={this.options(f, "subdivisions")}
									value={f.values.subdivision}
									onBlur={f.setFieldTouched}
									onChange={f.setFieldValue}
								/>
							</li>
						)}
						<li className={fieldStatus("prospect_count", f)}>
							<label htmlFor="prospect_count">
								Prospect Traffic<sup>*</sup>
							</label>
							{f.errors.prospect_count && f.touched.prospect_count && (
								<div className="form__message">{f.errors.prospect_count}</div>
							)}
							<NumberField
								name="prospect_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`prospect_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.prospect_count}
								error={f.errors.length > 0 && f.errors.prospect_count}
								value={f.values.prospect_count}
								numeric={true}
							/>
						</li>
						<li className={fieldStatus("realtor_count", f)}>
							<label htmlFor="realtor_count">
								Realtor Traffic<sup>*</sup>
							</label>
							{f.errors.realtor_count && f.touched.realtor_count && (
								<div className="form__message">{f.errors.realtor_count}</div>
							)}
							<NumberField
								name="realtor_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`realtor_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.realtor_count}
								error={f.errors.length > 0 && f.errors.realtor_count}
								value={f.values.realtor_count}
								numeric={true}
							/>
						</li>
					</ul>
					<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	formLayoutRows = (f) => {
		let propertyOptions = []
		_.forEach(this.props.payload.salespersonPayload.info.properties, (v) => {
			let b = _.find(this.props.payload.public.properties, { id: v })
			if (b) {
				propertyOptions.push({ value: v, label: b.name })
			}
		})
		//? Sections on traffic.
		let sections
		try {
			if (settings?.enabled?.sectionsOnTraffic) {
				let opts = []
				_.forEach(this.props.payload.public.sections, (v) => {
					if (v.property == f.values.property) {
						opts.push({ value: v.id, label: v.name })
					}
				})
				sections = (
					<li className={`${fieldStatus("section_id", f)}`}>
						<label htmlFor="section">
							Section <sup>*</sup>
						</label>
						{f.errors.length > 0 && f.errors.section_id && f.touched.section_id && (
							<div className="form__message">{f.errors.section_id}</div>
						)}
						<ReactSelect
							name={`section_id`}
							options={opts}
							value={f.values.section_id}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
						/>
					</li>
				)
			}
		} catch (e) {
			console.log(e)
		}
		return (
			<div>
				{console.log(f)}
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("property", f)}>
							<label htmlFor="property">Community</label>
							{f.errors.length > 0 && f.errors.property && f.touched.property && (
								<div className="form__message">{f.errors.property}</div>
							)}
							<ReactSelect
								name={`property`}
								options={propertyOptions}
								value={f.values.property}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						<li className={fieldStatus("builder", f)}>
							<label htmlFor="builder">
								Builder <sup>*</sup>
							</label>
							{f.errors.length > 0 && f.errors.builder && f.touched.builder && (
								<div className="form__message">{f.errors.builder}</div>
							)}
							<ReactSelect
								name={`builder`}
								options={transformOptionsObject(this.props.payload.salespersonPayload.builders)}
								value={f.values.builder}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{sections}
						<li className={fieldStatus("traffic_date", f)}>
							<label htmlFor="traffic_date">
								Traffic Date <sup>*</sup>
							</label>
							{f.errors.traffic_date && f.touched.traffic_date && (
								<div className="form__message">{f.errors.traffic_date}</div>
							)}
							<DateField
								name="traffic_date"
								className="form__textarea"
								value={f.values.traffic_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.traffic_date}
								error={f.errors.traffic_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("lot_type", f)}>
							<label htmlFor="lot_type">Lot Type *</label>
							{f.errors.length > 0 && f.errors.lot_type && f.touched.lot_type && (
								<div className="form__message">{f.errors.lot_type}</div>
							)}
							<ReactSelect
								name={`lot_type`}
								options={this.lotTypes(f)}
								value={f.values.lot_type}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
						{settings.enabled && settings.enabled.subdivisionOnTraffic && (
							<li className={fieldStatus("subdivision", f)}>
								<label htmlFor="subdivision">Subdivision</label>
								{f.errors.length > 0 && f.errors.subdivision && f.touched.subdivision && (
									<div className="form__message">{f.errors.subdivision}</div>
								)}
								<ReactSelect
									name={`subdivision`}
									options={this.options(f, "subdivisions")}
									value={f.values.subdivision}
									onBlur={f.setFieldTouched}
									onChange={f.setFieldValue}
								/>
							</li>
						)}
					</ul>
					<h3>Rows</h3>
					{f.errors?.trafficRows?.length > 0 && f.touched.trafficRows && (
						<div className="text-xs text-red-500">Please fill out all fields.</div>
					)}
					<TableRowField
						delete={true}
						initRow={true}
						fields={[
							{
								type: "select",
								name: "source",
								float: true,
								lookup: "trafficSources",
								header: "Traffic Source",
							},
							{
								type: "number",
								name: "prospect_count",
								header: "Prospect Count",
							},
							{
								type: "number",
								name: "realtor_count",
								header: "Realtor Count",
							},
						]}
						data={f.values.trafficRows}
						onChange={(v) => f.setFieldValue("trafficRows", v)}
					/>
					<div className="pt-6">
						<input type="submit" value="Submit" className={this.submitClasses(f.isValid)} />
					</div>
				</Form>
			</div>
		)
	}

	trafficTotal = () => {
		let user = currentUser()
		let c = 0
		_.forEach(this.props.payload.traffic.current.entries, (v) => {
			if (v.salesperson == user.id) {
				c++
			}
		})
		_.forEach(this.props.payload.traffic.current.grouped.array, (v) => {
			if (v.user == user.id) {
				c += v.prospect_count
				c += v.realtor_count
			}
		})
		return c
	}

	textingModule = () => {
		if (this.props.activeProperties.length !== 1) return ""
		let property = _.find(this.props.payload.public.properties, (r) => r.id == this.props.activeProperties[0])
		if (!property) return
		let models = _.map(this.props.payload.salespersonPayload.models, (v) => {
			return {
				value: v.id,
				label: v.address,
			}
		})
		if (property.copilot) {
			return <CoPilotTexting models={models} />
		}
		return ""
	}

	textingButton = () => {
		if (this.props.activeProperties.length !== 1) return ""
		let property = _.find(this.props.payload.public.properties, (r) => r.id == this.props.activeProperties[0])
		if (!property || !property?.copilot) return
		return (
			<span className="btn btn--row" onClick={() => this.setState({ texting: true })}>
				Text Walk-in Prospect
			</span>
		)
	}

	render() {
		var chartData = {
			labels: Object.keys(this.props.payload.traffic.currentChart),
			datasets: [
				{
					fill: false,
					data: Object.values(this.props.payload.traffic.currentChart),
				},
			],
		}

		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sale">
					<div className="imageGroup">
						<Title title="Traffic" />
						<div className="content">
							<div className="flex">
								{settings.disabled && settings.disabled.detailedTraffic !== true && (
									<Link to="/entry/traffic/new-traffic" className="btn btn--row">
										Add Detailed Traffic
									</Link>
								)}
								{settings.disabled && settings.disabled.groupedTraffic !== true && (
									<span
										className="btn btn--row"
										onClick={() => this.setState({ groupedTraffic: true })}>
										Add Grouped Traffic
									</span>
								)}
								{this.textingButton()}
							</div>

							<div className="fullCol">
								<div className="chartBlock">
									<p className="chartBlock__title">Total</p>
									<p className="chartBlock__dataTitle">{this.trafficTotal()}</p>
									<div className="chartContain">
										<div className="chartContain__cont">
											<Line options={graphOptions} data={chartData} />
										</div>
									</div>
								</div>
							</div>

							<div className="fullCol">
								<h3>Detailed Traffic</h3>
								<FullTable
									data={this.buildTable()}
									columns={this.state.iColumns}
									pageSize={15}
									name="builderPortal__traffic__detailed"
									title="Detailed Traffic"
								/>
							</div>
							{settings.disabled && settings.disabled.groupedTraffic !== true && (
								<div className="fullCol">
									<h3>Grouped Traffic</h3>
									<FullTable
										data={this.buildGroupedTable()}
										columns={this.state.gColumns}
										pageSize={15}
										name="builderPortal__traffic__grouped"
										title="Grouped Traffic"
									/>
								</div>
							)}
						</div>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.groupedTraffic}
							onClose={() => this.setState({ groupedTraffic: false })}
							center>
							<h3>Add Grouped Traffic</h3>
							{!settings?.enabled?.groupedTrafficSource ? (
								<Formik
									initialValues={fields}
									validationSchema={this.validation}
									enableReinitialize
									//validateOnMount={true}
									onSubmit={(values) => {
										//values.id = this.props.data.id
										//return

										submitData("inputGroupedTraffic", values)
											.then((data) => {
												toast.success(data.message)
												this.setState({ groupedTraffic: false })
											})
											.catch((e) => {
												toast.error(
													"Error inputting grouped traffic.  If the problem persists, please contact support."
												)
											})
									}}
									render={(f) => this.formLayout(f)}
								/>
							) : (
								<Formik
									initialValues={{
										property: 0,
										builder: 0,
										lot_type: 0,
										trafficRows: [],
										traffic_date: 0,
										subdivision: null,
										neighborhood: null,
										section_id: null,
									}}
									validationSchema={this.validationRows}
									enableReinitialize
									//validateOnMount={true}
									onSubmit={(values) => {
										//values.id = this.props.data.id
										//return

										submitData("inputGroupedTrafficRows", values)
											.then((data) => {
												toast.success(data.message)
												this.setState({ groupedTraffic: false })
											})
											.catch((e) => {
												toast.error(
													"Error inputting grouped traffic.  If the problem persists, please contact support."
												)
											})
									}}
									render={(f) => this.formLayoutRows(f)}
								/>
							)}
						</Modal>
						<Modal
							classNames={{ modal: "modalForm" }}
							open={this.state.texting}
							onClose={() => this.setState({ texting: false })}
							center>
							{this.textingModule()}
						</Modal>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		trafficSources: state.trafficSources,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Traffic))
